import { FC } from "react";
import ProductWebLayout from "./WebLayout";

const Product: FC = () => {
  return (
    <div>
      <ProductWebLayout />
    </div>
  );
};

export default Product;
